import { useTranslation } from "react-i18next";

import { v7 as uuidv7 } from "uuid";

import { NewsDto } from "../..";
import Checkbox from "../../../../../../components/CheckBox/Checkbox";

interface ReleaseNotesCheckProps {
  onCheckboxChange: () => void;
  isLoading: boolean;
  unpublishedReleaseNote: NewsDto[] | [];
  isChecked: boolean;
}

const ReleaseNotesCheck = ({
  onCheckboxChange,
  isLoading,
  unpublishedReleaseNote,
  isChecked
}: ReleaseNotesCheckProps) => {
  const { t } = useTranslation();

  const editDialogTooltip =
    isChecked &&
    unpublishedReleaseNote?.length > 0 &&
    t("Dialog##edit release notes tooltip");

  return (
    <Checkbox
      id={uuidv7()}
      customId="-release-notes"
      info={t("Dialog##make release notes info")}
      label={t("Dialog##make release notes")}
      onChange={onCheckboxChange}
      disabled={isLoading || unpublishedReleaseNote?.length > 0}
      customStyle={{ margin: "16px 0 8px 0" }}
      hasTooltip={unpublishedReleaseNote?.length > 0}
      tooltipTitle={editDialogTooltip || t("Dialog##unpublished release notes")}
      checked={isChecked}
    />
  );
};

export default ReleaseNotesCheck;
